"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.reducer = exports.actionCreators = void 0;
var common_impl_1 = require("./common-impl");
var configs_1 = require("../configs");
var auth = require("../authProvider");
// -----------------
// STATE - This defines the type of data maintained in the Redux store.
var MessagesActionTypes;
(function (MessagesActionTypes) {
    MessagesActionTypes["REQUEST_STARTED"] = "MESSAGES_REQUEST_STARTED";
    MessagesActionTypes["REQUEST_SUCCEEDED"] = "MESSAGES_REQUEST_SUCCEEDED";
    MessagesActionTypes["REQUEST_FAILED"] = "MESSAGES_REQUEST_FAILED";
})(MessagesActionTypes || (MessagesActionTypes = {}));
// ----------------
// ACTION CREATORS - These are functions exposed to UI components that will trigger a state transition.
// They don't directly mutate state, but they can have external side-effects (such as loading data).
exports.actionCreators = {
    requestMessages: function (startIndex, maxCount, cmd) { return function (dispatch, getState) {
        var appState = getState();
        if (cmd === 'f' || (appState && appState.messages && startIndex !== appState.messages.startIndex)) {
            var tenantId = auth.getTenantId();
            dispatch({ type: MessagesActionTypes.REQUEST_STARTED });
            fetch(configs_1.BASE_API_URI + "/messages/" + tenantId + "?startIndex=" + startIndex + "&maxCount=" + maxCount, {
                'headers': {
                    'x-api-key': configs_1.QUERY_API_KEY
                },
                'method': 'GET'
            })
                .then(common_impl_1.handleErrors)
                .then(function (response) { return response.json(); })
                .then(function (result) {
                dispatch({ type: MessagesActionTypes.REQUEST_SUCCEEDED, messages: result.messages, startIndex: startIndex, totalMessagesCount: result.totalMessagesCount });
            })
                .catch(function (error) {
                if (error.text) {
                    error.text().then(function (errorText) {
                        return dispatch({
                            type: MessagesActionTypes.REQUEST_FAILED, error: errorText
                        });
                    });
                }
                else {
                    dispatch({
                        type: MessagesActionTypes.REQUEST_FAILED, error: configs_1.ERROR_GENERIC_MESSAGE
                    });
                }
            });
        }
    }; }
};
// ----------------
// REDUCER - For a given state and action, returns the new state. To support time travel, this must not mutate the old state.
var unloadedState = {
    isLoading: false,
    messageEntities: [],
    error: null,
    totalMessagesCount: 0
};
var reducer = function (state, incomingAction) {
    if (state === undefined) {
        return unloadedState;
    }
    var action = incomingAction;
    switch (action.type) {
        case MessagesActionTypes.REQUEST_STARTED:
            return {
                isLoading: true,
                messageEntities: state.messageEntities,
                error: null,
                startIndex: state.startIndex,
                totalMessagesCount: 0
            };
        case MessagesActionTypes.REQUEST_SUCCEEDED:
            return {
                isLoading: false,
                messageEntities: action.messages,
                error: null,
                startIndex: action.startIndex,
                totalMessagesCount: action.totalMessagesCount
            };
        case MessagesActionTypes.REQUEST_FAILED:
            return {
                isLoading: false,
                messageEntities: state.messageEntities,
                error: action.error,
                startIndex: state.startIndex,
                totalMessagesCount: state.totalMessagesCount
            };
        default:
            return state;
    }
};
exports.reducer = reducer;
//# sourceMappingURL=messages.store.js.map